import { useSelector } from 'react-redux';

import useIsRegionalHubClouder from './useIsRegionalHubClouder';

export const CLOUDER_TYPE_NORMAL = 'NORMAL';
export const CLOUDER_TYPE_EXTERNAL = 'EXTERNAL';

export default function useCanAccessBankAccount() {
  const { isRegionalHubClouder, isLoading: isLoadingRegionalHub } =
    useIsRegionalHubClouder();
  const clouderTypeFromStore = useSelector((state) => state.auth.clouderType);
  const clouderType =
    clouderTypeFromStore || localStorage.getItem('clouderType') || '';

  const isNormalClouder = clouderType === CLOUDER_TYPE_NORMAL;
  const canAccessBankAccount = !isRegionalHubClouder || isNormalClouder;
  const isLoading =
    isLoadingRegionalHub || (isRegionalHubClouder && !clouderType);

  return {
    canAccessBankAccount,
    clouderType,
    isLoading,
    isNormalClouder,
  };
}
